// Only user-uploaded images are used. Treatments without an assigned image have empty gallery.
const HERO = "https://customer-assets.emergentagent.com/job_aesthetic-premium-1/artifacts/29jcnkaf_IMG_3034.JPG";
const IPL_MAIN = "https://customer-assets.emergentagent.com/job_aesthetic-premium-1/artifacts/zbqcwcds_IMG_3111.PNG";
const IPL_FACE = "https://customer-assets-eiarnc6j.emergentagent.net/job_aesthetic-premium-1/artifacts/3wqemn4y_5105370661063953563.jpg";
const IPL_LEGS = "https://customer-assets-eiarnc6j.emergentagent.net/job_aesthetic-premium-1/artifacts/5t8ehir7_5105370661063953564.jpg";
const HYDRA_MAIN = "https://customer-assets.emergentagent.com/job_aesthetic-premium-1/artifacts/f0586dce_IMG_3109.PNG";
const SKINPEN_MAIN = "https://customer-assets-eiarnc6j.emergentagent.net/job_aesthetic-premium-1/artifacts/iqb1a77y_5105370661063953565.jpg";

export const treatments = [
  {
    slug: "morpheus8",
    name: "Morpheus8",
    tagline: "Fractional radiofrequency remodelling for firmer, refined skin.",
    price: "$850",
    priceNote: "3 sessions — $750 per session",
    time: "1 hour 30 minutes",
    downtime: "3–5 days",
    sessions: "3 sessions, 4–6 weeks apart",
    image: HERO,
    gallery: [HERO],
    imageFit: "cover",
    overview: "A refined subdermal remodelling treatment that pairs microneedling with radiofrequency energy to lift, tighten and restore youthful contour with medical precision.",
    howItWorks: "Ultrafine gold-tipped needles deliver radiofrequency energy beneath the skin, stimulating collagen and elastin remodelling at controlled depths for structural rejuvenation.",
    bestFor: ["Loss of firmness", "Fine lines & wrinkles", "Enlarged pores", "Acne scarring", "Skin laxity", "Jawline definition"],
    benefits: ["Long-lasting firmness", "Refined texture", "Improved tone", "Subtle contour lift", "Minimal downtime"],
    resultsTimeline: "Visible improvement within 3 weeks. Full remodelling continues over 3–6 months.",
    preparation: ["Avoid retinoids for 5 days prior", "No sun exposure 48h before", "Arrive with clean skin", "Stay hydrated"],
    aftercare: ["Gentle hydrating cleanser only", "Broad-spectrum SPF 50 daily", "Avoid heat and sweat 48h", "No active ingredients for 5 days"],
    notCandidate: ["Active skin infections", "Pregnancy or breastfeeding", "Certain autoimmune conditions", "Isotretinoin within 6 months"]
  },
  {
    slug: "hydrafacial-deluxe",
    name: "Hydrafacial Deluxe",
    tagline: "Deep cleansing, gentle exfoliation and luminous hydration in one signature ritual.",
    price: "$280",
    time: "1 hour 20 minutes",
    downtime: "None",
    sessions: "Monthly for optimal glow",
    image: HYDRA_MAIN,
    gallery: [HYDRA_MAIN],
    imageFit: "cover",
    overview: "A three-step medical facial that cleanses, extracts and hydrates using patented vortex technology, followed by targeted boosters chosen for your skin.",
    howItWorks: "A hydro-dermabrasion tip loosens impurities, extracts congestion and infuses antioxidant serums, peptides and hyaluronic acid deep into the dermis.",
    bestFor: ["Dullness", "Congestion", "Dehydration", "Uneven tone", "Pre-event glow", "All skin types"],
    benefits: ["Immediate luminosity", "Refined pores", "Plump hydration", "Zero downtime", "Gentle yet effective"],
    resultsTimeline: "Radiance visible immediately; sustained clarity with monthly treatment.",
    preparation: ["Avoid retinoids 3 days prior", "No waxing 48h before", "Arrive make-up free if possible"],
    aftercare: ["SPF 50 daily", "Avoid heavy make-up 24h", "Hydrate generously", "Sleep on clean linen"],
    notCandidate: ["Active cold sores", "Sunburned skin", "Recent chemical peels within 2 weeks"]
  },
  {
    slug: "ipl-lumecca",
    name: "IPL Lumecca",
    tagline: "High-intensity photofacial that refines tone, clarity and pigmentation.",
    price: "$350",
    priceNote: "3 sessions — $900 total",
    time: "45 minutes",
    downtime: "1–3 days",
    sessions: "2–4 sessions, monthly",
    image: IPL_MAIN,
    gallery: [IPL_MAIN, IPL_FACE],
    imageFit: "cover",
    imageAspect: "1/1",
    overview: "A next-generation intense pulsed light treatment that targets sun damage, redness and vascular concerns to restore a clear, even complexion.",
    howItWorks: "Precisely calibrated wavelengths of light are absorbed by pigment and vessels, fragmenting discolouration for the body to clear naturally.",
    bestFor: ["Sun damage", "Age spots", "Rosacea & redness", "Freckles", "Vascular lesions", "Uneven tone"],
    benefits: ["Clarity and luminosity", "Reduced pigmentation", "Diminished redness", "Refreshed complexion"],
    resultsTimeline: "Pigment darkens then flakes off within 5–10 days; clarity improves progressively.",
    preparation: ["No sun exposure 4 weeks prior", "Discontinue retinoids 7 days", "Avoid self-tanner 2 weeks"],
    aftercare: ["Strict SPF 50", "Avoid heat 48h", "Do not pick darkened spots", "Gentle cleansing only"],
    notCandidate: ["Recent tan or self-tan", "Pregnancy", "Photosensitising medications", "Certain skin conditions"]
  },
  {
    slug: "skinpen",
    name: "Microneedling SkinPen",
    tagline: "FDA-cleared medical microneedling for smoother, more resilient skin.",
    price: "$350",
    time: "1 hour 30 minutes",
    downtime: "1–2 days",
    sessions: "3 sessions, 4 weeks apart",
    image: SKINPEN_MAIN,
    gallery: [SKINPEN_MAIN],
    imageFit: "cover",
    overview: "The gold standard in microneedling — an FDA-cleared device that stimulates the skin's natural repair to smooth texture, refine scars and restore glow.",
    howItWorks: "Sterile micro-channels are created in the dermis, initiating a controlled healing cascade that boosts collagen and elastin production.",
    bestFor: ["Acne scars", "Fine lines", "Enlarged pores", "Stretch marks", "Uneven texture"],
    benefits: ["Refined texture", "Firmer skin", "Reduced scarring", "Improved product absorption"],
    resultsTimeline: "Subtle glow within a week; structural improvement over 4–12 weeks.",
    preparation: ["Discontinue retinoids 3 days prior", "No sun exposure 48h", "Come with clean skin"],
    aftercare: ["Gentle hydration only for 72h", "SPF 50 daily", "No active ingredients 5 days", "Avoid heat, sweat 48h"],
    notCandidate: ["Active acne breakout", "Pregnancy", "Keloid tendency", "Recent isotretinoin use"]
  },
  {
    slug: "microneedling-rejuran",
    name: "Microneedling Rejuran",
    tagline: "A signature dual protocol pairing microneedling with polynucleotide healing.",
    price: "$480",
    time: "1 hour 30 minutes",
    downtime: "2–3 days",
    sessions: "3 sessions, 3–4 weeks apart",
    image: null,
    gallery: [],
    overview: "A bespoke protocol combining medical microneedling with Rejuran polynucleotides to accelerate regeneration and deliver luminous, resilient skin.",
    howItWorks: "Micro-channels are created to allow polynucleotides derived from salmon DNA to be infused, activating profound cellular repair.",
    bestFor: ["Dull, tired skin", "Fine lines", "Loss of elasticity", "Post-inflammatory pigmentation", "Sensitivity"],
    benefits: ["Deep regeneration", "Restored radiance", "Improved elasticity", "Reduced sensitivity"],
    resultsTimeline: "Glow within 7–10 days; layered rejuvenation over 8–12 weeks.",
    preparation: ["Avoid retinoids 5 days prior", "Hydrate well", "Discontinue actives 3 days"],
    aftercare: ["Bland moisturisers only", "SPF 50 diligently", "Avoid heat 48h", "No make-up 24h"],
    notCandidate: ["Salmon or fish allergy", "Pregnancy", "Active infection", "Autoimmune flare"]
  },
  {
    slug: "lumecca-legs",
    name: "IPL Lumecca Legs",
    tagline: "Targeted photofacial for smoother, clearer legs.",
    price: "$450",
    time: "",
    downtime: "1–3 days",
    sessions: "2 sessions recommended",
    image: IPL_LEGS,
    gallery: [IPL_LEGS],
    imageFit: "contain",
    imageAspect: "1/1",
    overview: "A dedicated IPL Lumecca protocol calibrated for the legs — refining vascular concerns, spider veins and uneven tone with medical precision.",
    howItWorks: "Precisely calibrated wavelengths of intense pulsed light are absorbed by vessels and pigment on the legs, fragmenting discolouration for the body to clear naturally.",
    bestFor: ["Spider veins", "Vascular lesions", "Uneven leg tone", "Sun-damaged skin on legs"],
    benefits: ["Clearer legs", "Reduced vascular appearance", "Even tone", "Confidence in bare skin"],
    resultsTimeline: "Progressive clearing over 2–6 weeks after each session.",
    preparation: ["No sun exposure 4 weeks prior", "Avoid self-tanner 2 weeks", "Shave the treatment area the day before"],
    aftercare: ["Strict SPF on treated areas", "Avoid heat 48h", "Do not pick or rub treated skin", "Gentle cleansing only"],
    notCandidate: ["Recent tan or self-tan", "Pregnancy", "Photosensitising medications", "Active infection or open wounds"]
  }
];

export const getTreatment = (slug) => treatments.find(t => t.slug === slug);
